import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderPage } from "../../../components/layouts/PlaceholderPage";
import { requireModuleAccess, MODULE_SITE_MANAGEMENT } from "../../../lib/auth/route-protection";
import { useI18n } from "../../../lib/i18n";

function SiteReportsPage() {
  const { t } = useI18n();
  return <PlaceholderPage title={t("pro.site.reportsTitle")} />;
}

export const Route = createFileRoute("/site/reports/")({
  beforeLoad: requireModuleAccess(MODULE_SITE_MANAGEMENT),
  component: SiteReportsPage,
});
